// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/thefaceshop_inklipquid.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/profile/captain.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/samsung.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section3_container__kDlS9 {
  position: relative;
}

@font-face {
  font-family: 'thefaceshop_inklipquid'; /* 폰트 이름 지정 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

.section3_item__fmkHS {
  text-align: center;
  color: white;
  position: absolute;
}

.section3_item-1__P7DoT {
  background-color: #0072BB;
  left: 0; /* Item2의 왼쪽 절반에 오버랩되도록 */
  top: 0;
}

.section3_item-2__aT72S {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); /* public 폴더 내 이미지 사용 */
}

.section3_samsung__OcuLo {
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); /* public 폴더 내 이미지 사용 */
  top: 5%;
  width : 70vw;
  height : 30vh;
  z-index: 2000;
  background-size: contain;
  background-repeat: no-repeat;
}


/* 큰 화면에서 두 div가 오버랩되도록 */
@media (min-width: 1586px) {
  .section3_container__kDlS9 {
    position: relative; /* 절대 위치로 배치되도록 설정 */
    height: 600px; /* 적당한 높이로 설정 */
  }

  .section3_item__fmkHS {
    position: absolute;
    height: 600px; /* 기본 높이 설정 */
  }

  .section3_item-1__P7DoT {
    width: 50%; /* Item1의 너비는 Item2의 절반 */
    z-index: 0; /* Item1이 Item2 위로 오버랩되도록 설정 */
    clip-path: polygon(0 0, 85% 0, 100% 100%, 0 100%); /* 우변만 기울이기 */
  }

  .section3_item-2__aT72S {
    background-size: auto 55vw;
    background-position: right  calc(50% + 5vw);;
    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */
    width: 100%; /* Item2는 전체 너비를 차지 */
    left: 0;
    top: 0;
  }
  .section3_text-bottom__3uyI4 {
    display: flex; /* 하단은 Flex로 배치 */
    justify-content: space-between; /* 두 항목을 평행하게 배치 */
    width: 90%; /* 컨테이너 너비에 맞게 */  
  }

  .section3_text-0__4Rkh3 {
    text-align: left;
    padding-left: 5%;
    color: white;
  }

  .section3_text-1__TTwQK {
    color: white;
    font-family: 'thefaceshop_inklipquid';
    font-size: 65px;
    letter-spacing: 10px;
  }

  .section3_text-2__pliJi {
    text-align: left;
    line-height: 2;
    color: white;
    font-size: 20px;
    padding-right: 5%;
  }

  .section3_text-3__jRgd2 {
    text-align: left;
    line-height: 2;
    color: white;
    font-size: 20px;
    padding-left: 5%;
  }

  .section3_text-4__RLk\\+x {
    text-align: left;
    line-height: 2;
    color: white;
    font-size: 20px;
    padding-left: 5%;
  }
}

/* 큰 화면에서 두 div가 오버랩되도록 */
@media (min-width: 1249px) and (max-width: 1585px) {
  .section3_container__kDlS9 {
    position: relative; /* 절대 위치로 배치되도록 설정 */
    height: 600px; /* 적당한 높이로 설정 */
  }

  .section3_item__fmkHS {
    height: 600px; /* 기본 높이 설정 */
  }

  .section3_item-1__P7DoT {
    width: 50%; /* Item1의 너비는 Item2의 절반 */
    z-index: 0; /* Item1이 Item2 위로 오버랩되도록 설정 */
    clip-path: polygon(0 0, 85% 0, 100% 100%, 0 100%); /* 우변만 기울이기 */
    width: 60%;
  }

  .section3_item-2__aT72S {
    background-size: auto 600px;
    background-position: right  center;
    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */
    width: 100%; /* Item2는 전체 너비를 차지 */
    left: 0;
    top: 0;
  }

  .section3_text-bottom__3uyI4 {
    display: flex; /* 하단은 Flex로 배치 */
    justify-content: space-between; /* 두 항목을 평행하게 배치 */
    width: 90%; /* 컨테이너 너비에 맞게 */
    
  }

  .section3_text-0__4Rkh3 {
    text-align: left;
    padding-left: 5%;
    color: white;
  }

  .section3_text-1__TTwQK {
    color: white;
    font-family: 'thefaceshop_inklipquid';
    font-size: 65px;
    letter-spacing: 10px;
  }

  .section3_text-2__pliJi {
    text-align: left;
    line-height: 2;
    color: white;
    font-size: 20px;
    padding-right: 5%;
  }

  .section3_text-3__jRgd2 {
    text-align: left;
    line-height: 2;
    color: white;
    font-size: 20px;
    padding-left: 5%;
  }

  .section3_text-4__RLk\\+x {
    text-align: left;
    line-height: 2;
    color: white;
    font-size: 20px;
    padding-left: 5%;
  }

}

/* 작은 화면에서는 두 div가 세로로 배치 */
@media (min-width: 768px) and (max-width: 1248px) {
  .section3_container__kDlS9 {
      display: flex;
      flex-direction: column; /* 세로 정렬 */
      align-items: center; /* 가로 중앙 정렬 */
      justify-content: center; /* 세로 중앙 정렬 (필요할 경우) */
  }

  .section3_item__fmkHS {
    position: relative;
    width: 100%; /* 작은 화면에서는 두 div가 전체 너비를 차지하도록 */
    height: 800px;
  }

  .section3_item-2__aT72S {
    background-size: cover; /* 이미지가 div를 가득 채우도록 */
    background-position: center; /* 이미지를 div의 중앙에 배치 */
    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */
    width: 100%; /* Item2는 전체 너비를 차지 */
    left: 0;
    top: 0;
    z-index: 2; /* Item1이 Item2 위로 오버랩되도록 설정 */
  }

  .section3_text-0__4Rkh3 {
    text-align: right;
    padding-right: 5%;
    color: white;
  }

  .section3_text-1__TTwQK {
    text-align: right;
    color: white;
    font-family: 'thefaceshop_inklipquid';
    font-size: 65px;
    letter-spacing: 10px;
  }

  .section3_text-2__pliJi {
    text-align: right;
    line-height: 2;
    padding-right: 5%;
    color: white;
    font-size: 20px;
  }

  .section3_text-3__jRgd2 {
    text-align: right;
    line-height: 2;
    padding-right: 5%;
    color: white;
    font-size: 20px;
  }

  .section3_text-4__RLk\\+x {
    text-align: right;
    line-height: 2;
    padding-right: 5%;
    color: white;
    font-size: 20px;
  }
}



@media (max-width: 767px) {
  .section3_container__kDlS9 {
      display: flex;
      flex-direction: column; /* 세로 정렬 */
      align-items: center; /* 가로 중앙 정렬 */
      justify-content: center; /* 세로 중앙 정렬 (필요할 경우) */
  }

  .section3_item__fmkHS {
    position: relative;
    text-align: center;
    color: white;
    width : 100%;
    
  }

  .section3_item-2__aT72S {
    background-size: cover; /* 이미지가 div를 가득 채우도록 */
    background-position: center; /* 이미지를 div의 중앙에 배치 */
    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */
    height : 70vw;
    left: 0;
    top: 0;
    z-index: 0; /* Item1이 Item2 위로 오버랩되도록 설정 */
  }

  .section3_text-0__4Rkh3 {
    text-align: right;
    padding-right: 5%;
    color: white;
  }

  .section3_text-1__TTwQK {
    text-align: right;
    color: white;
    font-family: 'thefaceshop_inklipquid';
    font-size: 35px;
    letter-spacing: 10px;
  }

  .section3_text-2__pliJi {
    text-align: right;
    line-height: 2;
    padding-right: 5%;
    color: white;
    font-size: 15px;
  }

  .section3_text-3__jRgd2 {
    text-align: right;
    line-height: 2;
    padding-right: 5%;
    color: white;
    font-size: 12px;
  }

  .section3_text-4__RLk\\+x {
    text-align: right;
    line-height: 2;
    padding-right: 5%;
    color: white;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Sections/section3.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC,EAAE,aAAa;EACpD,+DAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,OAAO,EAAE,yBAAyB;EAClC,MAAM;AACR;;AAEA;EACE,yDAAyD,EAAE,uBAAuB;AACpF;;AAEA;EACE,kBAAkB;EAClB,yDAAiD,EAAE,uBAAuB;EAC1E,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,4BAA4B;AAC9B;;;AAGA,yBAAyB;AACzB;EACE;IACE,kBAAkB,EAAE,oBAAoB;IACxC,aAAa,EAAE,eAAe;EAChC;;EAEA;IACE,kBAAkB;IAClB,aAAa,EAAE,aAAa;EAC9B;;EAEA;IACE,UAAU,EAAE,yBAAyB;IACrC,UAAU,EAAE,8BAA8B;IAC1C,iDAAiD,EAAE,aAAa;EAClE;;EAEA;IACE,0BAA0B;IAC1B,2CAA2C;IAC3C,4BAA4B,EAAE,kBAAkB;IAChD,WAAW,EAAE,qBAAqB;IAClC,OAAO;IACP,MAAM;EACR;EACA;IACE,aAAa,EAAE,iBAAiB;IAChC,8BAA8B,EAAE,kBAAkB;IAClD,UAAU,EAAE,gBAAgB;EAC9B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,kBAAkB,EAAE,oBAAoB;IACxC,aAAa,EAAE,eAAe;EAChC;;EAEA;IACE,aAAa,EAAE,aAAa;EAC9B;;EAEA;IACE,UAAU,EAAE,yBAAyB;IACrC,UAAU,EAAE,8BAA8B;IAC1C,iDAAiD,EAAE,aAAa;IAChE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,kCAAkC;IAClC,4BAA4B,EAAE,kBAAkB;IAChD,WAAW,EAAE,qBAAqB;IAClC,OAAO;IACP,MAAM;EACR;;EAEA;IACE,aAAa,EAAE,iBAAiB;IAChC,8BAA8B,EAAE,kBAAkB;IAClD,UAAU,EAAE,gBAAgB;;EAE9B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;AAEF;;AAEA,2BAA2B;AAC3B;EACE;MACI,aAAa;MACb,sBAAsB,EAAE,UAAU;MAClC,mBAAmB,EAAE,aAAa;MAClC,uBAAuB,EAAE,sBAAsB;EACnD;;EAEA;IACE,kBAAkB;IAClB,WAAW,EAAE,iCAAiC;IAC9C,aAAa;EACf;;EAEA;IACE,sBAAsB,EAAE,sBAAsB;IAC9C,2BAA2B,EAAE,qBAAqB;IAClD,4BAA4B,EAAE,kBAAkB;IAChD,WAAW,EAAE,qBAAqB;IAClC,OAAO;IACP,MAAM;IACN,UAAU,EAAE,8BAA8B;EAC5C;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;AACF;;;;AAIA;EACE;MACI,aAAa;MACb,sBAAsB,EAAE,UAAU;MAClC,mBAAmB,EAAE,aAAa;MAClC,uBAAuB,EAAE,sBAAsB;EACnD;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;;EAEd;;EAEA;IACE,sBAAsB,EAAE,sBAAsB;IAC9C,2BAA2B,EAAE,qBAAqB;IAClD,4BAA4B,EAAE,kBAAkB;IAChD,aAAa;IACb,OAAO;IACP,MAAM;IACN,UAAU,EAAE,8BAA8B;EAC5C;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".container {\n  position: relative;\n}\n\n@font-face {\n  font-family: 'thefaceshop_inklipquid'; /* 폰트 이름 지정 */\n  src: url('/src/fonts/thefaceshop_inklipquid.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.item {\n  text-align: center;\n  color: white;\n  position: absolute;\n}\n\n.item-1 {\n  background-color: #0072BB;\n  left: 0; /* Item2의 왼쪽 절반에 오버랩되도록 */\n  top: 0;\n}\n\n.item-2 {\n  background-image: url(/public/images/profile/captain.jpg); /* public 폴더 내 이미지 사용 */\n}\n\n.samsung {\n  position: absolute;\n  background-image: url(/public/images/samsung.png); /* public 폴더 내 이미지 사용 */\n  top: 5%;\n  width : 70vw;\n  height : 30vh;\n  z-index: 2000;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n\n/* 큰 화면에서 두 div가 오버랩되도록 */\n@media (min-width: 1586px) {\n  .container {\n    position: relative; /* 절대 위치로 배치되도록 설정 */\n    height: 600px; /* 적당한 높이로 설정 */\n  }\n\n  .item {\n    position: absolute;\n    height: 600px; /* 기본 높이 설정 */\n  }\n\n  .item-1 {\n    width: 50%; /* Item1의 너비는 Item2의 절반 */\n    z-index: 0; /* Item1이 Item2 위로 오버랩되도록 설정 */\n    clip-path: polygon(0 0, 85% 0, 100% 100%, 0 100%); /* 우변만 기울이기 */\n  }\n\n  .item-2 {\n    background-size: auto 55vw;\n    background-position: right  calc(50% + 5vw);;\n    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */\n    width: 100%; /* Item2는 전체 너비를 차지 */\n    left: 0;\n    top: 0;\n  }\n  .text-bottom {\n    display: flex; /* 하단은 Flex로 배치 */\n    justify-content: space-between; /* 두 항목을 평행하게 배치 */\n    width: 90%; /* 컨테이너 너비에 맞게 */  \n  }\n\n  .text-0 {\n    text-align: left;\n    padding-left: 5%;\n    color: white;\n  }\n\n  .text-1 {\n    color: white;\n    font-family: 'thefaceshop_inklipquid';\n    font-size: 65px;\n    letter-spacing: 10px;\n  }\n\n  .text-2 {\n    text-align: left;\n    line-height: 2;\n    color: white;\n    font-size: 20px;\n    padding-right: 5%;\n  }\n\n  .text-3 {\n    text-align: left;\n    line-height: 2;\n    color: white;\n    font-size: 20px;\n    padding-left: 5%;\n  }\n\n  .text-4 {\n    text-align: left;\n    line-height: 2;\n    color: white;\n    font-size: 20px;\n    padding-left: 5%;\n  }\n}\n\n/* 큰 화면에서 두 div가 오버랩되도록 */\n@media (min-width: 1249px) and (max-width: 1585px) {\n  .container {\n    position: relative; /* 절대 위치로 배치되도록 설정 */\n    height: 600px; /* 적당한 높이로 설정 */\n  }\n\n  .item {\n    height: 600px; /* 기본 높이 설정 */\n  }\n\n  .item-1 {\n    width: 50%; /* Item1의 너비는 Item2의 절반 */\n    z-index: 0; /* Item1이 Item2 위로 오버랩되도록 설정 */\n    clip-path: polygon(0 0, 85% 0, 100% 100%, 0 100%); /* 우변만 기울이기 */\n    width: 60%;\n  }\n\n  .item-2 {\n    background-size: auto 600px;\n    background-position: right  center;\n    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */\n    width: 100%; /* Item2는 전체 너비를 차지 */\n    left: 0;\n    top: 0;\n  }\n\n  .text-bottom {\n    display: flex; /* 하단은 Flex로 배치 */\n    justify-content: space-between; /* 두 항목을 평행하게 배치 */\n    width: 90%; /* 컨테이너 너비에 맞게 */\n    \n  }\n\n  .text-0 {\n    text-align: left;\n    padding-left: 5%;\n    color: white;\n  }\n\n  .text-1 {\n    color: white;\n    font-family: 'thefaceshop_inklipquid';\n    font-size: 65px;\n    letter-spacing: 10px;\n  }\n\n  .text-2 {\n    text-align: left;\n    line-height: 2;\n    color: white;\n    font-size: 20px;\n    padding-right: 5%;\n  }\n\n  .text-3 {\n    text-align: left;\n    line-height: 2;\n    color: white;\n    font-size: 20px;\n    padding-left: 5%;\n  }\n\n  .text-4 {\n    text-align: left;\n    line-height: 2;\n    color: white;\n    font-size: 20px;\n    padding-left: 5%;\n  }\n\n}\n\n/* 작은 화면에서는 두 div가 세로로 배치 */\n@media (min-width: 768px) and (max-width: 1248px) {\n  .container {\n      display: flex;\n      flex-direction: column; /* 세로 정렬 */\n      align-items: center; /* 가로 중앙 정렬 */\n      justify-content: center; /* 세로 중앙 정렬 (필요할 경우) */\n  }\n\n  .item {\n    position: relative;\n    width: 100%; /* 작은 화면에서는 두 div가 전체 너비를 차지하도록 */\n    height: 800px;\n  }\n\n  .item-2 {\n    background-size: cover; /* 이미지가 div를 가득 채우도록 */\n    background-position: center; /* 이미지를 div의 중앙에 배치 */\n    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */\n    width: 100%; /* Item2는 전체 너비를 차지 */\n    left: 0;\n    top: 0;\n    z-index: 2; /* Item1이 Item2 위로 오버랩되도록 설정 */\n  }\n\n  .text-0 {\n    text-align: right;\n    padding-right: 5%;\n    color: white;\n  }\n\n  .text-1 {\n    text-align: right;\n    color: white;\n    font-family: 'thefaceshop_inklipquid';\n    font-size: 65px;\n    letter-spacing: 10px;\n  }\n\n  .text-2 {\n    text-align: right;\n    line-height: 2;\n    padding-right: 5%;\n    color: white;\n    font-size: 20px;\n  }\n\n  .text-3 {\n    text-align: right;\n    line-height: 2;\n    padding-right: 5%;\n    color: white;\n    font-size: 20px;\n  }\n\n  .text-4 {\n    text-align: right;\n    line-height: 2;\n    padding-right: 5%;\n    color: white;\n    font-size: 20px;\n  }\n}\n\n\n\n@media (max-width: 767px) {\n  .container {\n      display: flex;\n      flex-direction: column; /* 세로 정렬 */\n      align-items: center; /* 가로 중앙 정렬 */\n      justify-content: center; /* 세로 중앙 정렬 (필요할 경우) */\n  }\n\n  .item {\n    position: relative;\n    text-align: center;\n    color: white;\n    width : 100%;\n    \n  }\n\n  .item-2 {\n    background-size: cover; /* 이미지가 div를 가득 채우도록 */\n    background-position: center; /* 이미지를 div의 중앙에 배치 */\n    background-repeat: no-repeat; /* 이미지를 반복하지 않도록 */\n    height : 70vw;\n    left: 0;\n    top: 0;\n    z-index: 0; /* Item1이 Item2 위로 오버랩되도록 설정 */\n  }\n\n  .text-0 {\n    text-align: right;\n    padding-right: 5%;\n    color: white;\n  }\n\n  .text-1 {\n    text-align: right;\n    color: white;\n    font-family: 'thefaceshop_inklipquid';\n    font-size: 35px;\n    letter-spacing: 10px;\n  }\n\n  .text-2 {\n    text-align: right;\n    line-height: 2;\n    padding-right: 5%;\n    color: white;\n    font-size: 15px;\n  }\n\n  .text-3 {\n    text-align: right;\n    line-height: 2;\n    padding-right: 5%;\n    color: white;\n    font-size: 12px;\n  }\n\n  .text-4 {\n    text-align: right;\n    line-height: 2;\n    padding-right: 5%;\n    color: white;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section3_container__kDlS9`,
	"item": `section3_item__fmkHS`,
	"item-1": `section3_item-1__P7DoT`,
	"item-2": `section3_item-2__aT72S`,
	"samsung": `section3_samsung__OcuLo`,
	"text-bottom": `section3_text-bottom__3uyI4`,
	"text-0": `section3_text-0__4Rkh3`,
	"text-1": `section3_text-1__TTwQK`,
	"text-2": `section3_text-2__pliJi`,
	"text-3": `section3_text-3__jRgd2`,
	"text-4": `section3_text-4__RLk+x`
};
export default ___CSS_LOADER_EXPORT___;
